class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.recalculateCartDrawerPrices()
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }


  renderCartHtml(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    // this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState[section.id], section.selector);

      // logic to open additional products
      const vectorIcons = document.querySelectorAll('.product-details__container');
      const blockFlexes = document.querySelectorAll('.additional_group-flexx');

      blockFlexes.forEach((blockFlex) => {
        blockFlex.style.maxHeight = '0px';
      });

      vectorIcons.forEach((vectorIcon) => {
        vectorIcon.addEventListener('click', (e) => {
          const clickedVectorIcon = e.currentTarget;
          const flexBlock = clickedVectorIcon.querySelector('.additional_group-flexx');
          if(flexBlock) {
            const isSlideDown = flexBlock.classList.contains('slide-down');

            flexBlock.classList.toggle('slide-down');
            const maxHeight = isSlideDown ? '0px' : flexBlock.scrollHeight + 'px';
            flexBlock.style.maxHeight = maxHeight;
          }
        });
      });
    });

    this.recalculateCartDrawerPrices()

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }
  
  recalculateCartDrawerPrices () {
    const productBlock = document.querySelectorAll('[data-count]');
    productBlock.forEach(section => {
          const additionalPrices = section.querySelectorAll('[data-additional-price]');

          // Create an array to store all additional prices
          const additionalPriceValues = [];

          additionalPrices.forEach(additionalPriceElement => {
              const additionalPriceValue = parseFloat(additionalPriceElement.getAttribute('data-additional-price'));
              if (!isNaN(additionalPriceValue)) {
                  additionalPriceValues.push(additionalPriceValue);
              }
          });


          const productPrice = section.querySelector('.product-price');
          const localizationForm = document.querySelector('localization-form .localization-form__button');
          const validSymbol = localizationForm.getAttribute('valid-symbol');
          console.log(productPrice);


          if (productPrice && additionalPriceValues.length > 0) {

              const currentPrice = parseFloat(productPrice.getAttribute('data-original-price'));
              const sumOfAdditionalPrices = additionalPriceValues.reduce((a, b) => a + b, 0);
              const newPrice = currentPrice + sumOfAdditionalPrices;
                productPrice.innerHTML = Shopify.formatMoney(newPrice, `${validSymbol} {{amount}}`);
          }
      });
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      // {
      //   id: 'cart-icon-bubble',
      // },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
  return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
